import { Notification } from 'entities/notification/model/types'
import { FC } from 'react';
import NotificationItem from '../Notification/Notification';
import { Empty, Typography, Flex, Skeleton, Button } from 'antd';
import { useIntl } from 'react-intl';

type Props = {
  notifications?: Notification[];
  count?: number;
  setNotificationDrawer: (notification: Notification) => unknown;
  isLoading: boolean;
  isFetching?: boolean;
  onDeleteNotification?: (id: number) => void;
  onShowMore?: () => void;
  limit: number;
  offset: number;
}

export const NotificationList: FC<Props> = ({ 
  notifications, 
  count, 
  setNotificationDrawer, 
  isLoading, 
  isFetching,
  onDeleteNotification,
  onShowMore,
  limit,
  offset,
}) => {
  const { formatMessage: t } = useIntl(); 
  const isNull = count === 0 && offset !== 0;

  if (isLoading) {
    return (
      <Flex vertical gap={16}>
        <Skeleton.Node style={{ height: 140, width: '100%' }} />
        <Skeleton.Node style={{ height: 140, width: '100%' }} />
        <Skeleton.Node style={{ height: 140, width: '100%' }} />
      </Flex>
    )
  }

  return (
    <>
      {(count !== 0 || isNull) ? (
        <Flex vertical gap={16} style={{ width: '100%' }}>
          {notifications?.map((notification) => (
            <NotificationItem
              id={notification.id}
              title={notification.parameters.title}
              text={notification.parameters.text}
              date={notification.date}
              onClick={() => setNotificationDrawer(notification)}
              onDelete={onDeleteNotification}
              key={notification.id}
            />
          ))}

          {!!notifications && count === limit &&  (
            <Button
              type="default"
              loading={isFetching}
              onClick={onShowMore}
              style={{ width: '50%', alignSelf: 'center' }}
            >
              {t({ id: 'buttons.showMore' })}
            </Button>
          )}
        </Flex>
      ) : (
        <Empty
          description={
            <Typography.Text>{t ({ id: 'notificationList.no' })}</Typography.Text>
          }
        />
      )}
    </>
  )
}